import { FormattedMessage } from 'react-intl';

import { TPersonalGuaranteeRequirement } from '../../fundingRequirements.types';
import { RequirementItem } from '../RequirementItem/RequirementItem';

export const PersonalGuarantee = ({
    status
}: TPersonalGuaranteeRequirement) => {
    return (
        <RequirementItem
            title={
                <FormattedMessage
                    id="_.funding_requirements_v2.type.personal_guarantee"
                    defaultMessage="Sign your personal guarantee"
                />
            }
            estimatedTime={
                <FormattedMessage
                    id="_.funding_requirements_v2.time.2_min"
                    defaultMessage="~ 2 Min."
                />
            }
            status={status}
        />
    );
};
